module.exports = __webpack_public_path__ + "static/media/create.edf4e8ea.png";